import { makeKeyValueRepository } from '../../../repositories/key-value/key-value-repository-factory';
import { makeEventService } from '../event/event-service-factory';
import { makeLogService } from '../log/log/log-service-factory';
import { makeTranslateService } from '../translate/translate-service-factory';
import {
  AppConfig,
  createDefaultAppConfig,
  IConfigService,
} from './config-service';
import { ConfigServiceImpl } from './config-service-impl';

let configService: IConfigService;
export const config: AppConfig = createDefaultAppConfig();

export function makeConfigService(): IConfigService {
  if (!configService) {
    configService = new ConfigServiceImpl(
      makeLogService(),
      makeEventService(),
      makeTranslateService(),
      makeKeyValueRepository(),
      config,
    );
  }

  return configService;
}
